import { render, staticRenderFns } from "./AnswerSubmitDialogue.vue?vue&type=template&id=d4bb899e&"
import script from "./AnswerSubmitDialogue.vue?vue&type=script&lang=js&"
export * from "./AnswerSubmitDialogue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports